// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__+nLYo","selected":"Dropdown_selected__Jpsyv"};